
export function buildSubscriptionFromState(state){
    const signupData = state.signupData;
    const selectedData = (signupData.selectedData || {});
    const summary = state.summary;
    let subscription = {};
    subscription.pickupSite = summary.pickupSite.key;
    subscription.paymentPlan = selectedData.selectedPaymentPlan ? selectedData.selectedPaymentPlan.key : undefined;
    subscription.pickupSiteWaitList = summary.waitListSite? summary.waitListSite.key : undefined;
    subscription.signupComments = selectedData.signupComments;
    if (selectedData.homeDeliveryInstructions) {
        subscription.signupComments = (subscription.signupComments || '') + '@@@' + selectedData.homeDeliveryInstructions;
    }
    if (selectedData.coupon)
        subscription.coupon = selectedData.coupon.id;

    const shares = signupData.sharesData.shares;
    const options = signupData.sharesData.options;
    const sharesAndOptions = Object.assign({}, shares, options);
    let shareItems = [];
    let shareItemPrices = [];
    let shareItemQuantities = [];
    let shareItemSchedules = [];
    let waitListItems = [];

    for(let key in sharesAndOptions){
        const item = shares.hasOwnProperty(key) ? shares[key] : options[key];
        if(item.quantity > 0){
            if(item.waitList){
                waitListItems.push(item.key);
            }else {
                shareItems.push(item.key);
                shareItemPrices.push(item.price);
                shareItemQuantities.push(item.quantity);
                shareItemSchedules.push(item.selectedSchedule);
            }
        }
    }
    subscription.shareItems = shareItems;
    subscription.shareItemPrices = shareItemPrices;
    subscription.shareItemQuantities = shareItemQuantities;
    subscription.shareItemSchedules = shareItemSchedules;
    subscription.waitListItems = waitListItems;

    return subscription;
}


// WEBPACK FOOTER //
// ./src/common/subscription.js